import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { updateLLMProject } from "../graphql/mutations";
import {
  UpdateLLMProjectMutation,
} from "../API";

export async function updateLLMProjectMaintenanceMode(
  id: string,
  maintenanceMode: boolean
): Promise<GraphQLResult<UpdateLLMProjectMutation>> {
  return API.graphql(
    graphqlOperation(updateLLMProject, {
      input: {
        id: id,
        maintenanceMode: maintenanceMode,
      },
    })
  ) as Promise<GraphQLResult<UpdateLLMProjectMutation>>;
}
